var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContinentEuropeCountryfrance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 3.75H15.75V20.25H8.25V3.75Z",
    fill: "#E6E7E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3.75C1.26488 3.75 0 5.59688 0 7.875V16.125C0 18.4031 1.26488 20.25 3.75 20.25H8.25V3.75H3.75Z",
    fill: "#1B75BB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.75H15.75V20.25H20.25C22.7351 20.25 24 18.4031 24 16.125V7.875C24 5.5965 23.9843 3.75 19.5 3.75Z",
    fill: "#EC1C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinentEuropeCountryfrance);
export default __webpack_public_path__ + "static/media/Continent=Europe, Country=france.bb25026986d13794b1a131602df53eb7.svg";
export { ForwardRef as ReactComponent };